import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Text,
  Box,
  BreadcrumbItem,
  Link,
  BreadcrumbLink,
  Flex,
} from "@chakra-ui/react";
import { Redirect } from "react-router-dom";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resetState } from "../../redux/actions/resetActions";
const Header = ({ dispatchResetState, template }) => {
  const [redirect, setRedirect] = useState(false);
  const handleRedirect = (e) => {
    e.preventDefault();
    setRedirect(true);
  };
  useEffect(() => {
    if (redirect) {
      dispatchResetState();
    }
  }, [redirect]);
  return (
    <div>
      {/* breadcrumb */}
      <Box className="template__header-wrapper">
        {!Object.keys(template).length && redirect ? (
          <Redirect
            to={{
              pathname: "/forms",
              bredcrumb: true,
            }}
          />
        ) : null}
        <Breadcrumb>
          <BreadcrumbItem fontSize="14px">
            <Flex align="center">
              <ChevronLeftIcon color="#27313A" width="20px" height="20px" />
              <BreadcrumbLink ml="2" color="#2c5cc5" href="#">
                <Link
                  color="#2c5cc5"
                  onClick={handleRedirect}
                  fontSize="14px"
                  fontWeight="600"
                >
                  Back to dashboard
                </Link>
              </BreadcrumbLink>
            </Flex>
          </BreadcrumbItem>
        </Breadcrumb>
        {/* title*/}
        <Box className="center-block">
          <Text align="center" fontSize="18px" fontWeight="600" color="27313A">
            Choose a Template
          </Text>
        </Box>
      </Box>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchResetState: bindActionCreators(resetState, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(Header);
